import { render, staticRenderFns } from "./TermsOfUseDialog.vue?vue&type=template&id=4dcd3b1f&scoped=true"
import script from "./TermsOfUseDialog.vue?vue&type=script&lang=js"
export * from "./TermsOfUseDialog.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUseDialog.vue?vue&type=style&index=0&id=4dcd3b1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd3b1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VSpacer})
